// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"8293b1e9","845":"49c15fb6"}[chunkId] + ".chunk.js";
};